"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegalAttributesImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing LegalAttributes operations. */
var LegalAttributesImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class LegalAttributes class.
   * @param client Reference to the service client
   */
  function LegalAttributesImpl(client) {
    (0, _classCallCheck2["default"])(this, LegalAttributesImpl);
    this.client = client;
  }
  /**
   * Returns true if document is a danish law (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
   * @param portalId (Access Controlled)
   * @param hiveId (Access Controlled)
   * @param fullName (Access Controlled)
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(LegalAttributesImpl, [{
    key: "isDkLaw",
    value: function isDkLaw(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, isDkLawOperationSpec);
    }
  }]);
  return LegalAttributesImpl;
}(); // Operation Specifications


exports.LegalAttributesImpl = LegalAttributesImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var isDkLawOperationSpec = {
  path: "/api/Portals({portalId})/legal/attributes/isDkLaw/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Boolean"
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};